// GoogleOAuthProvider.js
import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GoogleProvider = ({ children }) => {
    return (
        <GoogleOAuthProvider clientId="229632452913-mro9ps38hnbathbdpv73j126llgali6v.apps.googleusercontent.com">
            {children}
        </GoogleOAuthProvider>
    );
};

export default GoogleProvider;
